// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.league-tournament__groups__navbar {
    width: 100%;
    display: flex;
    align-items: center;
    border-top: none;   
    gap: 10px;
    position: relative;
    overflow-x: scroll;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    overflow-y: hidden;
}

.league-tournament__groups__navbar {
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox */
}
.league-tournament__groups__navbar::-webkit-scrollbar { 
    display: none;  /* Safari and Chrome */
}

.league-tournament__groups__navbar__hidden{
    display: none;
}

.league-tournament__groups__navbar button {
    border: 1px solid var( --basic-gray-color );
    border-radius: 24px;
    color: var( --basic-gray-color );
    padding: var( --space-half ) calc( var( --space ) + var( --space-quarter ) );
    text-wrap: nowrap;
}

.league-tournament__groups__navbar button:last-of-type {
    margin-right: 10px;
}

.league-tournament__groups__navbar button.active {
    color: var(--new-green-color);
    background-color: #EAF7F0; /* TODO missing variable, suggested Honeydew*/
    border: 1px solid var(--new-green-color);
}

.league-tournament__groups__navbar button:hover {
    cursor: pointer;    
}

.league-tournament__groups__navbar__arrow.next {
    right: 0;
    padding-top: 7px;
    padding-left: 5px;
    padding-right: 2px;
}

.league-tournament__groups__navbar__arrow.next .hubicon-arrow_circle_right{
    font-size: 22px;
}

.league-tournament__groups__navbar__arrow.prev {
    left: 0;
    padding-top: 7px;
    padding-right: 5px;
    padding-left: 2px;
}

.league-tournament__groups__navbar__arrow.prev .hubicon-arrow_circle_left{
    font-size: 22px;
}

.league-tournament__groups__navbar__arrow {
    position: sticky;
    /* top: 50%; */
    /* transform: translateY(16%); */
    width: 33px;
    height: calc(var(--space-x2) + 6px);
    cursor: pointer;
    z-index: 9;
    /* border-radius: 50%; */
    background-color: var(--white-color);
}
`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-groups-navbar/TournamentGroupsNavbarComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;IAC7B,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB,GAAG,0BAA0B;IACrD,qBAAqB,GAAG,YAAY;AACxC;AACA;IACI,aAAa,GAAG,sBAAsB;AAC1C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2CAA2C;IAC3C,mBAAmB;IACnB,gCAAgC;IAChC,4EAA4E;IAC5E,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB,EAAE,6CAA6C;IACxE,wCAAwC;AAC5C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,WAAW;IACX,mCAAmC;IACnC,eAAe;IACf,UAAU;IACV,wBAAwB;IACxB,oCAAoC;AACxC","sourcesContent":[".league-tournament__groups__navbar {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    border-top: none;   \n    gap: 10px;\n    position: relative;\n    overflow-x: scroll;\n    scroll-snap-type: x mandatory;\n    scroll-behavior: smooth;\n    overflow-y: hidden;\n}\n\n.league-tournament__groups__navbar {\n    -ms-overflow-style: none;  /* Internet Explorer 10+ */\n    scrollbar-width: none;  /* Firefox */\n}\n.league-tournament__groups__navbar::-webkit-scrollbar { \n    display: none;  /* Safari and Chrome */\n}\n\n.league-tournament__groups__navbar__hidden{\n    display: none;\n}\n\n.league-tournament__groups__navbar button {\n    border: 1px solid var( --basic-gray-color );\n    border-radius: 24px;\n    color: var( --basic-gray-color );\n    padding: var( --space-half ) calc( var( --space ) + var( --space-quarter ) );\n    text-wrap: nowrap;\n}\n\n.league-tournament__groups__navbar button:last-of-type {\n    margin-right: 10px;\n}\n\n.league-tournament__groups__navbar button.active {\n    color: var(--new-green-color);\n    background-color: #EAF7F0; /* TODO missing variable, suggested Honeydew*/\n    border: 1px solid var(--new-green-color);\n}\n\n.league-tournament__groups__navbar button:hover {\n    cursor: pointer;    \n}\n\n.league-tournament__groups__navbar__arrow.next {\n    right: 0;\n    padding-top: 7px;\n    padding-left: 5px;\n    padding-right: 2px;\n}\n\n.league-tournament__groups__navbar__arrow.next .hubicon-arrow_circle_right{\n    font-size: 22px;\n}\n\n.league-tournament__groups__navbar__arrow.prev {\n    left: 0;\n    padding-top: 7px;\n    padding-right: 5px;\n    padding-left: 2px;\n}\n\n.league-tournament__groups__navbar__arrow.prev .hubicon-arrow_circle_left{\n    font-size: 22px;\n}\n\n.league-tournament__groups__navbar__arrow {\n    position: sticky;\n    /* top: 50%; */\n    /* transform: translateY(16%); */\n    width: 33px;\n    height: calc(var(--space-x2) + 6px);\n    cursor: pointer;\n    z-index: 9;\n    /* border-radius: 50%; */\n    background-color: var(--white-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
